import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { isArray } from 'lodash'

@Component({
  selector: 'gb-skeleton-loader',
  templateUrl: './gb-skeleton-loader.component.html',
  styleUrls: ['./gb-skeleton-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbSkeletonLoaderComponent {
  @Input() set height(height: number | undefined) {
    if (height) this._height = `${height}px`
  }
  @Input() set width(width: number | number[] | string | string[] | undefined) {
    if (width) {
      if (isArray(width)) {
        this._widths = width.map((w) => (typeof w === 'string' ? w : `${w}%`))
      } else {
        this._widths = [typeof width === 'string' ? width : `${width}%`]
      }
    }
  }
  @Input() set count(count: number | undefined) {
    // set count as array to be iterable
    if (count) this._count = [...Array(count).keys()]
  }
  @Input() darkTheme = false
  @Input() appearance?: 'block' | 'circle' = 'block'
  @Input() direction?: 'row' | 'column' = 'column'
  @Input() gap = 5

  _height = '1rem'
  _widths = ['100']
  _count = [0]

  get circle(): boolean {
    return this.appearance === 'circle'
  }

  get row(): boolean {
    return this.direction === 'row'
  }

  constructor() {}
}
